import { useMemo } from 'react';
import { regionAwareImageUrlForFormat } from 'regionAwareImage';
import { type LinkToLessonInStream } from 'Lessons';
import clsx from 'clsx';
import trackIconLocked from 'vectors/track_icon_locked_slate_grey.svg';
import { Tooltip } from 'Tooltip';
import { parseHtml } from 'FrontRoyalAngular/html.utils';
import { linkStyles } from './shared';

type Props = { lessonLink: LinkToLessonInStream; canLaunch: boolean; reasonMessage: string | null };

export default function StreamLink({ lessonLink, canLaunch, reasonMessage }: Props) {
    const streamImage = useMemo(() => {
        if (!canLaunch) return trackIconLocked;
        if (!lessonLink.streamImage) return null;

        return regionAwareImageUrlForFormat(lessonLink.streamImage, '50X50');
    }, [lessonLink, canLaunch]);

    return (
        <div className="relative flex items-start">
            {streamImage && (
                <img
                    className="absolute -top-1 left-0 max-w-[25px] max-xs:top-0 rtl:left-auto rtl:right-0"
                    src={streamImage}
                    alt={lessonLink.streamTitle}
                />
            )}
            {canLaunch ? (
                <a
                    href={lessonLink.streamDashboardPath}
                    data-testid="stream-link"
                    target="_blank"
                    rel="noreferrer"
                    className={clsx(linkStyles, streamImage && 'ps-8')}
                >
                    {lessonLink.streamTitle}
                </a>
            ) : (
                <Tooltip content={<span className="whitespace-nowrap">{parseHtml(reasonMessage ?? '')}</span>}>
                    <span
                        className={clsx('cursor-not-allowed', 'text-slate-grey-600', streamImage && 'ps-8')}
                        data-testid="stream-link-locked"
                    >
                        {lessonLink.streamTitle}
                    </span>
                </Tooltip>
            )}
        </div>
    );
}
